import React, {
  PropsWithChildren,
  CSSProperties,
  forwardRef,
  ReactHTMLElement,
} from "react";
import { SpaceAtom } from "./atom";

export const Space = forwardRef<HTMLDivElement, SpaceProps>(function Space(
  {
    direction = "row",
    align = "flex-start",
    gap = 0,
    height = "max-content",
    width = "max-content",
    minWidth = "0px",
    children,
    className = "",
    justify = "space-between",
    padding = "0px",
    ...props
  },
  ref
) {
  return (
    <SpaceAtom
      direction={direction}
      align={align}
      gap={gap}
      width={width}
      height={height}
      className={className}
      justify={justify}
      padding={padding}
      ref={ref}
      {...props}
    >
      {children}
    </SpaceAtom>
  );
});

export type SpaceProps = PropsWithChildren<
  {
    direction?: string;
    column?: boolean;
    gap?: number;
    width?: string;
    height?: string;
    minWidth?: string;
    fitParent?: boolean;
    style?: CSSProperties;
    align?: string;
    center?: boolean;
    className?: string;
    justify?: string;
    padding?: number | string;
    position?: string;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    onDoubleClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    onHover?: (e: React.MouseEvent<HTMLDivElement>) => void;
  } & ReactHTMLElement
>;
